<ng-container *notInPopulation="[populations.Suite, populations.Pts]">
  <div class="full-page-container">
    <div class="d-block d-lg-none">
      <fgb-page-header
        [pageTitle]="'wallet.page.title'"
        [backButtonLink]="'/'"
        [showBalance]="false"
        [showQr]="false"
        [showFooter]="showQr"
      ></fgb-page-header>

      <div class="barcode-div">
        <fgb-barcode (onShowQr)="onShowQr($event)"></fgb-barcode>
      </div>
    </div>

    <fgb-banner [title]="'wallet.page.title' | translate"> </fgb-banner>

    <div #walletContainer class="wallet-container">
      <ng-container *ifScreenSize="screenType.Mobile">
        <div class="grab-point"><span class="minimize-icon"> </span></div>
      </ng-container>

      <ng-container *ngIf="walletItems$ | async as walletItems">
        <div class="wallet-redeem-carousel pt-4 pt-lg-0">
          <div class="container">
            <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
          </div>
        </div>
      </ng-container>

      <fgbcl-campaigns-offers-list [showAllOffers]="false"></fgbcl-campaigns-offers-list>

      <div class="container mt-4">
        <div class="history-container">
          <div class="history">
            <h5 class="title">{{ 'redemption.history.title' | translate }}</h5>
            <p class="description font-size-14 mb-0">{{ 'redemption.history.description' | translate }}</p>
          </div>
          <a class="font-size-14 claimed-text fw-bold text-center" [routerLink]="['/rewards/claimed']">
            {{ 'rewards.wallet.view.claimed' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Suite, populations.Pts]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
